module.exports = __webpack_public_path__ + "img/7.36b78139.jpg";